// hide_note.js: the mandatory reason Care must give when hiding or showing a teacher to trial
// students (PROD-9278). Mirrors validateHideNote in goserver session_reco/hide_note.go — the server
// is the gate, this only spares Care a round trip, so the two rules must stay identical.

export const HIDE_NOTE_MAX_LEN = 500;

export const HIDE_NOTE_REQUIRED = 'note is required';
export const HIDE_NOTE_TOO_LONG = `note must be ${HIDE_NOTE_MAX_LEN} characters or fewer`;

// Counts code points, not UTF-16 units, to match Go's utf8.RuneCountInString.
const rune_length = (text) => [...text].length;

/**
 * Validates a hide/unhide reason.
 * @param {string} note raw text from the textarea
 * @returns {{ value: string, error: string }} trimmed note, or the error to show (never both)
 */
export const validate_hide_note = (note) => {
  const trimmed = (note || '').trim();

  if (trimmed === '') {
    return { value: '', error: HIDE_NOTE_REQUIRED };
  }
  if (rune_length(trimmed) > HIDE_NOTE_MAX_LEN) {
    return { value: '', error: HIDE_NOTE_TOO_LONG };
  }
  return { value: trimmed, error: '' };
};

/**
 * Reads the message the API sent back, so Care sees why a save was refused rather than a bare
 * object. The care endpoints answer { status: 'failure', reason: '...' }.
 */
export const hide_note_error_message = (error) =>
  error?.response?.data?.reason || error?.message || 'Could not save. Please try again.';
